import { Link } from 'react-router-dom';

export default function TabbyBanner() {
  const installments = [
    { label: 'اليوم', highlight: true },
    { label: 'بعد شهر', highlight: false },
    { label: 'بعد شهرين', highlight: false },
    { label: 'بعد 3 أشهر', highlight: false },
  ];

  return (
    <section className="bg-[#3DBDA7] py-5 overflow-hidden relative" dir="rtl">
      {/* Decorative circles */}
      <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10" />
      <div className="absolute -left-6 -bottom-8 w-28 h-28 rounded-full bg-white/10" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Left: Tabby brand + message */}
        <div className="flex items-center gap-4">
          {/* Tabby logo-style badge */}
          <div className="bg-white rounded-xl px-4 py-2 flex items-center gap-2 shadow-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-bank-card-line text-[#3DBDA7] text-lg" />
            </div>
            <span className="text-[#3DBDA7] font-black text-lg tracking-wide">tabby</span>
          </div>
          <div className="text-white">
            <p className="font-black text-lg leading-snug">اشتر الآن، ادفع لاحقاً!</p>
            <p className="text-white/80 text-sm">قسّط مشترياتك على 4 دفعات بدون فوائد أو رسوم</p>
          </div>
        </div>

        {/* Center: 4 installments visual */}
        <div className="flex items-center gap-2">
          {installments.map((item, idx) => (
            <div key={item.label} className="flex items-center gap-2">
              <div
                className={`flex flex-col items-center px-3 py-2 rounded-lg text-center min-w-[72px] transition-all ${
                  item.highlight
                    ? 'bg-white text-[#3DBDA7] shadow'
                    : 'bg-white/20 text-white'
                }`}
              >
                <div className={`w-4 h-4 flex items-center justify-center mb-1`}>
                  <i className={`${item.highlight ? 'ri-checkbox-circle-fill' : 'ri-time-line'} text-sm`} />
                </div>
                <span className="text-xs font-bold whitespace-nowrap">{item.label}</span>
                <span className="text-xs mt-0.5 opacity-80">25%</span>
              </div>
              {idx < installments.length - 1 && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-left-s-line text-white/60 text-base" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Right: CTA */}
        <Link
          to="/payment"
          className="flex items-center gap-2 bg-white text-[#3DBDA7] font-bold px-6 py-3 rounded-full hover:bg-[#f0faf9] transition-all duration-300 cursor-pointer whitespace-nowrap shadow"
        >
          <span>تسوق بالتقسيط</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line text-sm" />
          </div>
        </Link>
      </div>
    </section>
  );
}
